// @flow
import LoadingButton from "@mui/lab/LoadingButton";
import * as React from "react";
import { Button } from "@mui/material";

export const CoimexButton = (props) => {
  return (
    // <LoadingButton
    //   {...props}
    //   loading={props.loading}

    //   className={`containerBtn ${props.className}`}
    //   variant="contained"
    // >
    //   <p className="text">{props.children}</p>
    // </LoadingButton>
    <Button
      onClick={props.onClick}
      className="bg-fontColorB  capitalize w-[99px] h-[42px] rounded-full text-white font-montserrat text-base"
    >
      {props.children}
    </Button>
  );
};
